var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIngressLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ingressLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 74,
    height: 75,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M53.176,35.69a1.859,1.859,0,0,1-1.858-1.858A13.023,13.023,0,0,0,38.309,20.823H20.345v8.053A1.861,1.861,0,0,1,17.2,30.219L3.575,17.21a1.856,1.856,0,0,1,0-2.686L17.2,1.515a1.86,1.86,0,0,1,3.142,1.343v8.053H35.831a19.226,19.226,0,0,1,19.2,19.2v3.717A1.859,1.859,0,0,1,53.176,35.69Z",
    transform: "translate(7.983 20.748)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngressLogo);
export default __webpack_public_path__ + "static/media/ingressLogo.e8951794d04a9f5b6bee6041c7985f2c.svg";
export { ForwardRef as ReactComponent };